import React, { FC } from 'react';
import { useHistory, useParams } from 'react-router';
import { ResetPasswordForm, useShowAlertPopup } from '@dew21/ui';
import axios from 'axios';

export const ResetPasswordRoute: FC = (props) => {
  const { token = null } = useParams();
  const showNotificationBanner = useShowAlertPopup();
  const history = useHistory();

  return (
    <>
      <ResetPasswordForm appName={'Administration'} onResetPasswordClick={(password, passwordRepeat) => {
        if (token && (password && passwordRepeat) && (password.length > 3) && password === passwordRepeat) {

          axios.post('/api/auth/password/reset', { password }, { headers: { dewSt: token } }).then((response) => {

            showNotificationBanner({
              error: false,
              renderContent: () => {
                return <>Ihr Passwort wurde erfolgreich aktualisiert. Sie erhalten eine separate E-Mail zur
                  Bestätigung.</>;
              },
            });

            history.push('/login');

          }).catch((error) => {
            showNotificationBanner({
              error: true,
              renderContent: () => {
                return <>Da ist etwas schief gelaufen. Bitte probieren sie es in 15 min erneut.</>;
              },
            });
          });

        } else {
          showNotificationBanner({
            error: true,
            renderContent: () => {
              return <>Bitte überprüfen Sie ihre Eingaben. Die eingegeben Passwörter stimmen nicht überein oder
                entsprechen nicht den Richtlinien der DEW21 GmbH.</>;
            },
          });
        }
      }}/>
    </>
  );
};
